import React from 'react';
import { Poppins } from 'src/common';
import styled from 'styled-components';

const Div = styled.div<{ $withIcon: boolean }>`
  display: grid;
  grid-template-columns: ${({ $withIcon }) => ($withIcon ? '12px auto' : 'auto')};
  align-items: center;
  grid-gap: 10px;

  &:hover {
    cursor: pointer;
    span {
      background: ${({ theme }) => theme.colors.gradient};
      -webkit-background-clip: text;
      color: transparent;
    }
    path {
      fill: ${({ theme }) => theme.colors.gp1};
    }
  }
`;

interface MenuItemProps {
  title: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

export const MenuItem: React.FC<MenuItemProps> = ({ title, onClick, icon }) => {
  return (
    <Div onClick={onClick} $withIcon={!!icon}>
      {icon && icon}
      <Poppins weight={500} px={14} color="cflowerBlue">
        {title}
      </Poppins>
    </Div>
  );
};
